export const reducer = (state, nextState) => ({ ...state, ...nextState })
